import { useQuery } from "@tanstack/react-query";

import { useSession } from "../Session/SessionContext";
import { fetchCustomerTab } from "./requests";
import { CustomerTab } from "./schema";

export const customerTabQueryKeys = {
  base: ["customerTab"] as const,
  current: (uuid: string) => [...customerTabQueryKeys.base, uuid],
} as const;
export const useCustomerTabQuery = (uuid?: string) => {
  return useQuery({
    queryKey: customerTabQueryKeys.current(uuid || "undefined"),
    queryFn: () => fetchCustomerTab({ uuid }),
    enabled: !!uuid,
  });
};

export const useCurrentCustomerTab = () => {
  const session = useSession();
  const { customerTab } = session;
  if (!customerTab?.uuid) {
    throw "Missing a customer tab";
  }
  return useQuery({
    queryKey: customerTabQueryKeys.current(customerTab.uuid),
    queryFn: () => fetchCustomerTab({ uuid: customerTab.uuid }),
  });
};

/*
 I thought this was a good idea, but its really not.
 Almost all of my "Whoops something went wrong" issues are being caused by this.
 Its so easy to use in the wrong place and accidentally throw an error. Thats very hard to debug
 */
export const useLoadedCustomerTab = (): {
  data: CustomerTab;
  isFetching: boolean;
} => {
  const { data, isError, error, isFetching, isPending } =
    useCurrentCustomerTab();
  if (isError) {
    throw `Error loading query, ${error.message}`;
  }
  if (isPending) {
    throw `Attempt to access loaded customer tab session that is  unloaded`;
  }
  if (!data) {
    throw `Attempt to access customer tab session that is  missing`;
  }

  return {
    data,
    isFetching,
  };
};
export const useCustomerTab = (uuid: string) =>
  useQuery({
    queryKey: ["customerTab", uuid],
    queryFn: () => fetchCustomerTab({ uuid }),
  });
